<template>
  <v-app>
    <div class="card card-custom">
      <div class="card-body p-0">
        <div
            class="wizard wizard-2"
            id="kt_wizard_v2"
            data-wizard-state="step-first"
            data-wizard-clickable="true"
        >
          <div class="wizard-body py-8 px-8 py-lg-10 px-lg-10">
            <div class="row">
              <div class="col-md-6 col-lg-6 col-sm-12">
                <h4> Quiz Result
                </h4>
                <router-link :to="{ name: 'dashboard' }">
                  Dashboard
                </router-link>
                \
                Quiz Result
              </div>
              <div class="col-md-6 col-lg-6 col-sm-12 text-right">
                <router-link :to="{name:'quiz'}" class="btn  btn-standard text-gray">
                  Cancel
                </router-link>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                    <td>Candidate Name</td>
                    <td>Marks Obtained</td>
                    <td>Remarks</td>
                    </thead>
                    <tbody v-if="quiz_result && quiz_result.length>0">
                    <tr v-for="(result, index) of quiz_result" :key="index">
                      <td class="">{{ result.user_full_name }}</td>
                      <td class="">{{ result.marks_obtained }}</td>
                      <td class="">
                        <span class="font-weight-bold"
                              :class="result.remarks == 'FAIL'?'text-danger':'text-success'">{{ result.remarks }}</span>
                      </td>
                    </tr>
                    </tbody>
                    <tbody v-else>
                    <tr>
                      <td colspan="50" class="text-center">No Data Found</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import {QuizMixin} from "@/mixins/QuizMixin";

export default {
  name: "Index",
  mixins: [QuizMixin],
  data() {
    return {}
  },
  computed: {
    quiz_id() {
      return this.$route.params.id
    }
  },
  mounted() {
    this.getQuizResult(this.quiz_id)
  }
}
</script>

<style scoped>

</style>